const addSuccessStoriesConstantsEn = {
  listOfSuccessStoriesTitle: 'Success Stories',
  successStoriesBreadcrumbs: 'Success Stories',
  addSuccessStoriesPageTitle: 'New Success Story',
  editSuccessStoriesPageTitle: 'Edit Success Story',
  successStoriesSaveDraftBtn: 'Save',
  successStoriesSaveBtn: 'save',
  successStoriesCreateBtn: 'Add Success Story',
  successStoriesName: 'Author name',
  successStoriesStatus: 'Status',
  successStoriesDraft: 'Draft',
  successStoriesPublished: 'Published',
  successStoriesDeleteDialogTitle: 'Delete Success Story',
  successStoriesDeleteDialogMessage: 'Are you sure you want to delete this success story?',
  successStoriesEdit: 'Edit',
  cmsSuccessStoriesTableState: 'Status',
  cmsSuccessStoriesTablePublishDate: 'Publish Date',
};

export default addSuccessStoriesConstantsEn;
